// Platform operator management (admin-portal). Invite-only onboarding of KaziPeople
// staff: list operators + pending invites, invite by email + platform role, revoke,
// activate/deactivate. The accept-invite calls are public (the invitee has no
// session yet). All go through the gateway to auth-service.
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);

export const OPERATOR_ROLES = [
  { value: 'platform_admin', label: 'Platform Admin — manage tenants & config' },
  { value: 'platform_support', label: 'Platform Support — read + support actions' },
  { value: 'platform_billing', label: 'Platform Billing — billing & plans' },
  { value: 'platform_analyst', label: 'Platform Analyst — analytics only' },
];

export interface Operator {
  id: string;
  email: string;
  name: string;
  roles: string[];
  isActive: boolean;
  self: boolean;
  createdAt: string;
}
export interface PendingInvite {
  id: string;
  email: string;
  role: string;
  invitedAt: string;
  expiresAt: string;
}
export interface OperatorsResponse {
  operators: Operator[];
  pendingInvites: PendingInvite[];
}

export const listOperators = () =>
  axios.get<OperatorsResponse>(`${API_V1}/platform/operators`).then((r) => r.data);

export const inviteOperator = (body: { email: string; name?: string; role: string }) =>
  axios.post(`${API_V1}/platform/operators/invite`, body).then((r) => r.data);

export const revokeInvite = (id: string) =>
  axios.delete(`${API_V1}/platform/operators/invites/${id}`).then((r) => r.data);

export const setOperatorActive = (userId: string, active: boolean) =>
  axios.post(`${API_V1}/platform/operators/${userId}/active`, { active }).then((r) => r.data);

// --- public (invitee, no session) ---
export const validateInvite = (token: string) =>
  axios.get(`${API_V1}/invitations/validate/${token}`).then((r) => r.data);

export const acceptInvite = (token: string, password: string, fullName?: string) =>
  axios.post(`${API_V1}/invitations/accept/${token}`, { password, fullName }).then((r) => r.data);
